// extracted by mini-css-extract-plugin
export default {"input":"GenericPost_input__H8JOx"};